<template>
  <label class="uploadImgBtn customBtn">
    <UploadImgIcon />
    <span class="load f14">{{ text }}<span class="accept" v-if="accept">JPEG, PNG</span></span>
    <input
      class="fileInput"
      type="file"
      accept=".jpg, .jpeg, .png"
      v-on:change="handleFileUpload"
    />
  </label>
</template>

<script>
import UploadImgIcon from 'components/icons/personalArea/UploadImgIcon'
export default {
  name: 'ButtonImageAdd',
  props: ['text', 'click', 'disabled', 'rules', 'accept'],
  components: { UploadImgIcon },
  data() {
    return {
      file: null,
    }
  },
  methods: {
    async handleFileUpload(e) {
      this.file = e.target.files[0]
      // console.log(e.target.files[0])
      var reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      reader.onload = () => {
        this.$emit('buttonImageData', {
          file: this.file,
          base64: reader.result,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.uploadImgBtn {
  // border: 1px solid #277faf;
  // padding: 18px 24px;
  // height: max-content;
  // display: grid;
  // grid-template-columns: max-content auto auto;
  // width: max-content;
  // align-items: center;
  // grid-column-gap: 10px;
  // transition: background-color 0.3s;
  // cursor: pointer;
  width: auto !important;
  .load {
    font-size: 16px;
    line-height: 19px;
    font-weight: bold;
    color: #ffffff;
    display: flex;
    column-gap: 10px;
    justify-content: flex-start;
    .accept {
      color: #b4b4b4;
      font-weight: 400;
    }
  }

  .fileInput {
    display: none;
  }
  @media screen and (max-width: 500px) {
    svg {
      margin-right: 0;
    }
    .load {
      display: none;
    }
  }
}
</style>
